import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { SettingService } from './services/setting.service';
import { ListGroupSettingModel, SettingModel } from './model/setting.model';

@Component({
  selector: 'app-setting-component',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})

export class SettingComponent implements OnInit {
  currentUser: {};
  listGroupSettingModel: ListGroupSettingModel[];
  listSettingModel: SettingModel;
  groupId = null;
  propId = null;

  txtSearch: string = "*";
  lastElement: object = null;
  viewRef: ViewContainerRef;
  loading: boolean;
  processingConfirmation: boolean;
  errorMessages: string = null;

  constructor(
    viewRef: ViewContainerRef,
    private settingService: SettingService
  ) {
    this.viewRef = viewRef;
  }

  ngOnInit() {
    if (!this.loggedUser()) {
      window.location.href = "/authentication";
    }
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.getSettings();
  }

  public doSearch($event: Event) {
    this.txtSearch = ($event.target as HTMLInputElement).value;
    this.getSettings();
  }

  public doSearchClear() {
    this.txtSearch = "*";
    this.getSettings();
  }

  public refrehPage() {
    this.getSettings();
  }

  public getSettings() {
    this.loading = true;
    this.settingService.getSetting(this.txtSearch)
      .subscribe(result => {
        try {
          this.loading = false;
          this.listGroupSettingModel = result["result"];
        } catch (er) {
          this.loading = false;
          this.listGroupSettingModel = [];
        }
      });
  }

  public openModal(modelName, iG, iS, $event) {
    this.groupId = iG;
    this.propId = iS;
    try {
      document.getElementById(modelName).style.display = "block";
      document.getElementById(modelName).style.backgroundColor = "rgba(12, 0, 0, 0.5)";
    } catch (e) {
      let that = this;
      setTimeout(function () { that.openModal(modelName, iG, iS, $event); }, 500);

    }
  }

  public closeModal(modelName) {
    this.processingConfirmation = false;

    this.errorMessages = null;

    this.groupId = null;
    this.propId = null;

    document.getElementById(modelName).style.display = "none";
  }

  public editSave() {
    this.processingConfirmation = false;

    let model: SettingModel = {
      label: this.listGroupSettingModel[this.groupId].settings[this.propId].label,
      name: this.listGroupSettingModel[this.groupId].settings[this.propId].name,
      value: document.getElementById("settingValue")["value"]
    };

    this.loading = true;
    this.settingService.setSetting(model)
      .subscribe(result => {
        this.loading = false;
        this.getSettings();
      }, result => {
        // show errors result.error.errors
        this.loading = false;
        this.errorMessages = result.error.errors;
        this.openModal("modalErrors", null, null, null);
      });

    this.groupId = null;
    this.propId = null;
  }

  loggedUser() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      return true;
    }
  }
}

